import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useCloseNavOnRouteChange = (closeFn) => {
  const { pathname } = useLocation();

  useEffect(() => {
    closeFn(); // يقفل المنيو أول ما تتغير الصفحة
  }, [pathname]);
};

export default useCloseNavOnRouteChange;
